import { FieldSchema } from "../../../Schema";

export const updatedBy: FieldSchema = {
  name: "updatedBy",
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Updated by", disabled: true, displayed: false },
};
